import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class ChannelsQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number): Promise<any> {
    let args = { 
        company_id: company_id,
    }
    let res = undefined;    
    res = await this.dispatcher.dispatch('bank.channels.get', args)    
    if (res.status === '200') {
      this.frontend.channels = res.data      
    } else {
      return res.data
    }    
  }
}